export const MONITOR_NONE = "__none__";

export interface ExecutionFilters {
  customerKeys: string[];
  ticketStatuses: string[];
  statusCategories: string[];
  ticketTypes: string[];
  executionStatuses: string[];
  ticketQuery: string;
  startedAfter: string;
  startedBefore: string;
}

export const EMPTY_EXECUTION_FILTERS: ExecutionFilters = {
  customerKeys: [],
  ticketStatuses: [],
  statusCategories: [],
  ticketTypes: [],
  executionStatuses: [],
  ticketQuery: "",
  startedAfter: "",
  startedBefore: "",
};

export const STATUS_CATEGORY_OPTIONS = [
  { key: "unresolved", label: "Unresolved" },
  { key: "completed", label: "Completed" },
  { key: "unknown", label: "Unknown" },
];

export const EXECUTION_FILTER_OPTIONS = [
  { key: "running", label: "Running" },
  { key: "waiting", label: "Waiting" },
  { key: "success", label: "Success" },
  { key: "interrupted", label: "Interrupted" },
];

export const SUMMARY_WINDOWS = [
  { value: "all", label: "All time" },
  { value: "24h", label: "Last 24 hours" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
];

export interface AutoAgentMonitorFilterQuery {
  ticketId?: string;
  customerKeys?: string[];
  ticketStatuses?: string[];
  statusCategories?: string[];
  ticketTypes?: string[];
  executionStatuses?: string[];
  startedAfter?: string;
  startedBefore?: string;
}

export function toIsoQueryValue(localDateTime: string): string | undefined {
  const trimmed = localDateTime.trim();
  if (!trimmed) return undefined;
  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) return undefined;
  return parsed.toISOString();
}

export function buildMonitorQueryParams(filters: ExecutionFilters): AutoAgentMonitorFilterQuery {
  const params: AutoAgentMonitorFilterQuery = {};
  if (filters.customerKeys.length) params.customerKeys = filters.customerKeys;
  if (filters.ticketStatuses.length) params.ticketStatuses = filters.ticketStatuses;
  if (filters.statusCategories.length) params.statusCategories = filters.statusCategories;
  if (filters.ticketTypes.length) params.ticketTypes = filters.ticketTypes;
  if (filters.executionStatuses.length) params.executionStatuses = filters.executionStatuses;
  const ticketId = filters.ticketQuery.trim();
  if (ticketId) params.ticketId = ticketId;
  const startedAfter = toIsoQueryValue(filters.startedAfter);
  if (startedAfter) params.startedAfter = startedAfter;
  const startedBefore = toIsoQueryValue(filters.startedBefore);
  if (startedBefore) params.startedBefore = startedBefore;
  return params;
}

export function countActiveExecutionFilters(filters: ExecutionFilters): number {
  return [
    filters.customerKeys.length,
    filters.ticketStatuses.length,
    filters.statusCategories.length,
    filters.ticketTypes.length,
    filters.executionStatuses.length,
    filters.ticketQuery.trim(),
    filters.startedAfter,
    filters.startedBefore,
  ].filter(Boolean).length;
}

export function datesAreOutOfOrder(filters: ExecutionFilters): boolean {
  if (!filters.startedAfter || !filters.startedBefore) return false;
  return filters.startedAfter > filters.startedBefore;
}
